module.exports = __webpack_public_path__ + "static/media/Microsoft Lumia 950 Black.7081e07a.png";